module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-control-static"
  }, [(_vm.value && _vm.value.length === 0) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.i18n.fr('html.empty'))
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm._specs), function(_spec, i) {
    return _c('div', {
      staticStyle: {
        "margin-bottom": ".5em"
      }
    }, [(!_vm._readonly && _vm.spec.delete) ? _c('button', {
      staticClass: "btn btn-icon btn-danger",
      staticStyle: {
        "float": "left"
      },
      attrs: {
        "disabled": typeof _vm.spec.min === 'number' && _vm.value.length <= _vm.spec.min,
        "type": "button",
        "title": _vm.i18n.fr('action.delete')
      },
      on: {
        "click": function($event) {
          _vm.del(_spec.idx)
        }
      }
    }, [_c('i', {
      staticClass: "ti-minus"
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      style: ({
        'margin-left': _vm.spec.delete ? '44px' : 0
      })
    }, [(!_vm.spec.present) ? _c('div', [_vm._v(_vm._s(_vm.i18n.fr('fields.array_item_$i', {
      i: i + 1
    })))]) : _vm._e(), _vm._v(" "), _c(_vm.spec.itemType.component, {
      key: _spec.spec.prop,
      ref: "fields",
      refInFor: true,
      tag: "component",
      staticStyle: {
        "padding-top": "0"
      },
      attrs: {
        "name": _spec.spec.prop,
        "spec": _spec.spec,
        "model": _vm.value,
        "$parentForm": this,
        "rootModel": _vm.rootModel,
        "$rootForm": _vm.$rootForm,
        "readonly": _vm._readonly
      }
    }), _vm._v(" "), _c('small', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.validator.errors.has(String(_spec.idx))),
        expression: "validator.errors.has(String(_spec.idx))"
      }],
      staticClass: "text-danger"
    }, [_vm._v("\n        " + _vm._s(_vm.validator.errors.first(String(_spec.idx))) + "\n      ")])], 1)])
  }), _vm._v(" "), (!_vm._readonly && _vm.spec.add && !(typeof _vm.spec.max === 'number' && _vm.value.length >= _vm.spec.max)) ? _c('button', {
    staticClass: "btn btn-icon btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.add
    }
  }, [_c('i', {
    staticClass: "ti-plus"
  }), _vm._v("\n    " + _vm._s(_vm.i18n.fr('action.add')) + "\n  ")]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-81f38650!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Forms/Fields/f-array.vue
// module id = 527
// module chunks = 55